module.exports = __webpack_public_path__ + "static/media/arrow_up_24px.86280c4d.svg";